import { TranslationKeys } from "@/hooks/useTranslation/useTranslation"
import { BreadcrumbItem } from "@/types/breadcrumbs"

function getPathnameEnding(pathname: string) {
  const pathnameParts = pathname.split("/")
  const pageEnding = pathnameParts[pathnameParts.length - 1]
  return pageEnding
}

/**
 * Normalize page name by removing 'excel-' prefix
 * This treats 'excel-answers' and 'answers' as the same page
 */
function normalizePage(page: string): string {
  return page
    .replace(/^excel-/, "")
    .replace(/^pdf-/, "")
    .replace(/^qm-/, "")
}

function getTranslatedPageTitle(
  page: string,
  translate: (identifier: TranslationKeys) => string,
): string {
  switch (page) {
    case "upload":
      return translate("BREADCRUMBS_NAVIGATION/TITLE_UPLOAD")
    case "questions":
      return translate("BREADCRUMBS_NAVIGATION/TITLE_QUESTIONS")
    case "answers":
    case "excel-answers":
    case "qm-answers":
    case "pdf-answers":
      return translate("BREADCRUMBS_NAVIGATION/TITLE_ANSWERS")
    case "preview":
      return translate("BREADCRUMBS_NAVIGATION/TITLE_COMPLETE")
    default:
      return translate("BREADCRUMBS_NAVIGATION/TITLE_UNKNOWN")
  }
}

export function createBreadcrumbs(
  pathname: string,
  pages: string[],
  translate: (identifier: TranslationKeys) => string,
): BreadcrumbItem[] {
  const currentPage = normalizePage(getPathnameEnding(pathname))

  const breadcrumbs = pages.map((page) => {
    return {
      title: getTranslatedPageTitle(page, translate),
      isSelected: currentPage === normalizePage(page),
    }
  })
  return breadcrumbs
}

export function showBreadcrumbsNavigation(
  pathname: string,
  pages: string[],
): boolean {
  const pathEnding = getPathnameEnding(pathname)
  return pages.includes(pathEnding)
}
